import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

import { PasswordRules } from '@connect-services/client/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { FormErrorEnum } from '@shared/client/models/form.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-password-rules-verification',
    templateUrl: './password-rules-verification.component.html',
})
export class PasswordRulesVerificationComponent {
    public readonly control = input.required<FormControl<string>>();
    public readonly rules = input.required<PasswordRules>();

    protected readonly errors = signal<ValidationErrors | null>(null);
    protected readonly FormErrorEnum = FormErrorEnum;

    public constructor() {
        effect((onCleanup) => {
            const control = this.control();

            this.errors.set(control.errors);

            const subscription = control.statusChanges.subscribe(() => {
                this.errors.set(control.errors);
            });

            onCleanup(() => subscription.unsubscribe());
        });
    }
}
